import React, { useState } from 'react';
import ProjectCell from '../ProjectCell';
import { NtIcon } from '../NotionUI';
import { useLanguage } from '../../i18n/LanguageContext';
import Select from '../Select';

const NOT_SETTABLE = ['title', 'files', 'created_time', 'updated_time', 'created_by', 'updated_by', 'task_relation'];

/**
 * Barra delle azioni su più attività selezionate: duplica, elimina e
 * "imposta" lo stesso valore di una colonna su tutte.
 */
function BulkBar({ count, columns, users, allTasks, onDuplicate, onDelete, onSet, onClear }) {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const [columnId, setColumnId] = useState('');
  const settable = columns.filter((c) => !NOT_SETTABLE.includes(c.type));
  const column = settable.find((c) => String(c.id) === columnId) || null;
  // Cella "vuota" su cui si sceglie il valore da applicare.
  const blank = { id: 0, title: '', data: {}, tickets: [] };

  return (
    <div className="pd-bulk" role="toolbar" aria-label={t('projectDetail.bulkActions')}>
      <strong>{t('projectDetail.selectedCount', { count })}</strong>
      <button type="button" className="nt-ghost-btn" onClick={onDuplicate}><NtIcon name="copy" /> {t('projectDetail.duplicateTask')}</button>
      <button type="button" className="nt-ghost-btn" onClick={onDelete}><NtIcon name="trash" /> {t('projectDetail.deleteTask')}</button>
      <span className="pv-tab-wrap">
        <button type="button" className="nt-ghost-btn" onClick={() => setOpen(true)}><NtIcon name="edit" /> {t('projectDetail.setValue')}</button>
        {open && (
          <>
            <div className="pd-overlay" onClick={() => setOpen(false)} />
            <div className="pd-popover pd-bulk-set">
              <label className="pd-popover-label">{t('projectView.property')}</label>
              <Select value={columnId} onChange={(e) => setColumnId(e.target.value)} aria-label={t('projectView.property')}>
                <option value="">—</option>
                {settable.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
              </Select>
              {column && (
                <>
                  <label className="pd-popover-label">{t('projectView.filterValue')}</label>
                  <ProjectCell
                    key={column.id}
                    task={blank}
                    column={column}
                    users={users}
                    allTasks={allTasks}
                    onSave={(value) => { setOpen(false); setColumnId(''); onSet(column.id, value); }}
                    onTaskReplace={() => {}}
                    onError={() => {}}
                  />
                </>
              )}
            </div>
          </>
        )}
      </span>
      <button type="button" className="nt-ghost-btn pd-bulk-clear" onClick={onClear}>{t('projectDetail.clearSelection')}</button>
    </div>
  );
}

export default BulkBar;
